import {initVideoPlayers} from '../../../static/js/lib/plyr-init.js';

initVideoPlayers();
